<template>
    <div class="vh-full spd">

        <div>
            <svg viewBox="0 0 101 104" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                width="101.000000" height="104.000008" fill="none" customFrame="#000000">
                <g id="Group 26780">
                    <g id="Mask Group 1">
                        <path id="Ellipse 652"
                            d="M50.5 98.7342C78.3904 98.7342 101 76.6318 101 49.3671C101 22.1024 78.3904 0 50.5 0C22.6096 0 0 22.1024 0 49.3671C0 76.6318 22.6096 98.7342 50.5 98.7342Z"
                            fill="var(--emp-list-1)" fill-rule="evenodd" />
                        <g id="Group">
                            <path id="Rectangle 5615"
                                d="M79.4533 28.3038L21.5466 28.3038C19.6872 28.3038 18.1799 29.7773 18.1799 31.5949L18.1799 100.709C18.1799 102.527 19.6872 104 21.5466 104L79.4533 104C81.3126 104 82.8199 102.527 82.8199 100.709L82.8199 31.5949C82.8199 29.7773 81.3126 28.3038 79.4533 28.3038Z"
                                fill="var(--emp-list-2)" fill-rule="evenodd" />
                        </g>
                        <g id="Group 26776">
                            <path id="Rectangle 5617"
                                d="M43.7667 38.1772L26.26 38.1772C25.1444 38.1772 24.24 39.0613 24.24 40.1519C24.24 41.2425 25.1444 42.1266 26.26 42.1266L43.7667 42.1266C44.8823 42.1266 45.7867 41.2425 45.7867 40.1519C45.7867 39.0613 44.8823 38.1772 43.7667 38.1772Z"
                                fill="var(--emp-list-3)" fill-rule="evenodd" />
                            <path id="Rectangle 5618"
                                d="M55.8867 46.7342L26.26 46.7342C25.1444 46.7342 24.24 47.6183 24.24 48.7088C24.24 49.7994 25.1444 50.6835 26.26 50.6835L55.8867 50.6835C57.0023 50.6835 57.9067 49.7994 57.9067 48.7088C57.9067 47.6183 57.0023 46.7342 55.8867 46.7342Z"
                                fill="var(--emp-list-3)" fill-rule="evenodd" />
                        </g>
                        <g id="Group 26777">
                            <path id="Rectangle 5617"
                                d="M43.7667 55.9494L26.26 55.9494C25.1444 55.9494 24.24 56.8335 24.24 57.9241C24.24 59.0146 25.1444 59.8987 26.26 59.8987L43.7667 59.8987C44.8823 59.8987 45.7867 59.0146 45.7867 57.9241C45.7867 56.8335 44.8823 55.9494 43.7667 55.9494Z"
                                fill="var(--emp-list-3)" fill-rule="evenodd" />
                            <path id="Rectangle 5618"
                                d="M55.8867 64.5063L26.26 64.5063C25.1444 64.5063 24.24 65.3904 24.24 66.481C24.24 67.5716 25.1444 68.4557 26.26 68.4557L55.8867 68.4557C57.0023 68.4557 57.9067 67.5716 57.9067 66.481C57.9067 65.3904 57.0023 64.5063 55.8867 64.5063Z"
                                fill="var(--emp-list-3)" fill-rule="evenodd" />
                        </g>
                        <g id="Group 26778">
                            <path id="Rectangle 5617"
                                d="M43.7667 73.7215L26.26 73.7215C25.1444 73.7215 24.24 74.6056 24.24 75.6962C24.24 76.7868 25.1444 77.6709 26.26 77.6709L43.7667 77.6709C44.8823 77.6709 45.7867 76.7868 45.7867 75.6962C45.7867 74.6056 44.8823 73.7215 43.7667 73.7215Z"
                                fill="var(--emp-list-3)" fill-rule="evenodd" />
                            <path id="Rectangle 5618"
                                d="M55.8867 82.2785L26.26 82.2785C25.1444 82.2785 24.24 83.1626 24.24 84.2532C24.24 85.3437 25.1444 86.2278 26.26 86.2278L55.8867 86.2278C57.0023 86.2278 57.9067 85.3437 57.9067 84.2532C57.9067 83.1626 57.0023 82.2785 55.8867 82.2785Z"
                                fill="var(--emp-list-3)" fill-rule="evenodd" />
                        </g>
                    </g>
                </g>
            </svg>
        </div>
        <div class="mtip">{{text}}</div>
        <div style="height: 70px;"></div>
        <div @click="mainButtonClick" v-if="mainButton != ''" class="bnt-ms focus-s">{{ mainButton }}</div>
        <div v-if="options!=null && options.length > 0" class="mgt20">
            <div v-for="item in options" :key="item" class="opt-item">
                <IconMenu @click="optionClick(item)" :svgname="item.iconName" :name="item.name"
                    :iconSize="item.iconSize"></IconMenu>
            </div>
        </div>
        <div style="height: 150px;"></div>
    </div>
</template>

<script>
import SvgImage from './SvgImage.vue';
import IconMenu from './IconMenu.vue';
export default {
    name: 'ListEmptyView',
    components: {
        SvgImage,
        IconMenu
    },
    props: {
        text:{
            type:String,
            default:"暂无内容"
        },
        mainButton: {
            type: String,
            default: ""
        },
        options: Array
    },
    methods: {
        ///主要按钮点击
        mainButtonClick: function () {
            this.$emit("mainClick")
        },
        ///选项点击
        optionClick: function (item) {
            this.$emit("optionClick", item.key)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.mtip{
    margin-top: 20px;
    color: var(--ek-text-color2);
    font-size: 14px;
}

.spd {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    justify-content: center;
}

.bnt-ms {
    background: var(--ek-color-primary);
    padding-left: 50px;
    padding-right: 50px;
    line-height: 35px;
    color: white;
    border-radius: 10px;
    font-size: 14px;
}

.opt-item {
    margin-bottom: 15px;
}
</style>
